import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SeoRequestsFactory} from '../Requests/factory.js'
import {GetRemoteSeoDataSeoService} from '../Services/GetRemoteSeoDataSeoService.js'

class GetRemoteSeoDataSeoUseCase extends UseCase {
  #config
  #service

  constructor({config, service}) {
    super()
    this.#config = config
    this.#service = service
  }

  static create({config}) {
    return new GetRemoteSeoDataSeoUseCase({
      config,
      service: GetRemoteSeoDataSeoService.create({config})
    })
  }

  @tracer({metric: 'GetRemoteSeoDataSeoUseCase#execute'})
  @AsyncInlineError()
  async execute({culture, pageName, params, preloadImages, vehicleCount} = {}) {
    const seoDataRequestVO = SeoRequestsFactory.seoDataRequest({
      culture,
      pageName,
      params,
      preloadImages
    })

    const {canonical: canonicalUrl} = params || {}

    const [error, seoDataResponse] = await this.#service.execute({
      seoDataRequestVO,
      canonicalUrl,
      vehicleCount
    })

    if (error) return Promise.reject(error)

    return seoDataResponse.toJSON()
  }
}

export const factory = GetRemoteSeoDataSeoUseCase.create
